export const authDesktopVPadding = 20;
